import { Box } from "@mui/material"
import { RiskDetails } from "../../../riskAndIssues/components/RiskDetails"
import { useRiskRegister } from "../../../riskAndIssues/mutation";
import { DrawerControl } from "../../../../shared/components";
import { RaiseRisk } from "../../../riskAndIssues";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";


export const ContractorRiskDrawer = ({ riskId, projectId }: { riskId: number | null; projectId: string | undefined }) => {

    const [searchParams, setSearchParams] = useSearchParams();

    const { refetch } = useRiskRegister({
            projectId
        });

        const [raiseRisk, setRaiseRisk] = useState<{
                open: boolean,
                editStatus: boolean,
                riskId: string | null
            }>({
                open: false,
                editStatus: false,
                riskId: null
            });

            const id = searchParams.get("objectId");

  return (
    <Box height="100%" display="flex" flexDirection="column">
        <RiskDetails 
            riskId={String(riskId)} 
            onEdit={() => {
                setRaiseRisk({ open: true, editStatus: true, riskId: String(id) });
            }} 
            refetch={refetch} />
        <DrawerControl
                        width="35%"
                        title="Add/Edit Risk"
                        subTitle={""}
                        isOpen={raiseRisk.open}
                        handleClose={() => { setRaiseRisk({ open: false, editStatus: false, riskId: null }) }}
                        children={
                            <RaiseRisk
                                riskId={raiseRisk.riskId}
                                editStatus={raiseRisk.editStatus}
                                projectId={projectId}
                                onCancel={() => setRaiseRisk({ open: false, editStatus: false, riskId: null })}
                                refetch={refetch}
                            />
                        }
                    />
    </Box>
  )
}